import { useContext, useEffect } from "react";
import { NavContext } from "../contexts/NavContextProvider";
import { updateDocumentTitle } from "..";
import SubPageTitle from "../SubPageTitle";
import { MessageBar, MessageBarBody, MessageBarTitle, MessageBarActions, Button } from "@fluentui/react-components";
import { BeakerFilled } from "@fluentui/react-icons";

export default function ExperimentsPage() {
    const { navData, setNavData } = useContext(NavContext);

    useEffect(
        () => {
            updateDocumentTitle( "Experiments | All Experiments" );
            navData.sidebarSelectedNavValue = "experiments";
            navData.subPageNavValue = null;
            setNavData({...navData});
        },
        []
    );

    return (
        <>
            <SubPageTitle icon={<BeakerFilled />} title="Experiments" subTitle="All Experiments" />

            <MessageBar intent="warning" style={{ marginBottom: "1rem" }}>
                <MessageBarBody>
                    <MessageBarTitle>Experiments Disabled</MessageBarTitle>
                    Experiments are currently disabled for the active product. In order to use these features, you must enable experiments first.
                </MessageBarBody>
                <MessageBarActions>
                    <Button size="small">Enable</Button>
                </MessageBarActions>
            </MessageBar>
        </>
    );
}